/**
 * @file utils - Core utility functions for styling
 * @ai-pure: yes - No side effects, deterministic output
 * @ai-reusable: yes - Used across all components for className merging
 */

import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * @ai-hint: Merge Tailwind CSS classes with conflict resolution
 * @example cn("px-4 py-2", isActive && "bg-blue-500", className)
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
